import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { fetchObatByRkun } from "../../../redux/actions/history";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import ActionDialog from "../../../components/ActionDialog";
import AccordionObat from "../../../components/AccordionObat";

type Props = {
  actFetchObatByRkun: ({ rkun_id }: any) => void;
  stateHistoryFarmasi: any;
  open: boolean;
  setOpen: (open: boolean) => void;
};

const HistoryObat = (props: Props) => {
  const { actFetchObatByRkun, stateHistoryFarmasi, open, setOpen } = props;
  const { id } = useParams();

  React.useEffect(() => {
    if (open) actFetchObatByRkun({ rkun_id: id });
    return () => {};
  }, [open]);

  return (
    <>
      <ActionDialog
        open={open}
        label="Obat pulang"
        setOpen={(val: boolean) => setOpen(val)}
      >
        <Stack spacing={2}>
          <Box height="1vh"></Box>
          {stateHistoryFarmasi.length == 0 && (
            <Typography variant="body1" align="center">
              Data kosong
            </Typography>
          )}
          {stateHistoryFarmasi?.map((item: any) => (
            <AccordionObat
              obats={item.items}
              tanggal={item.tanggal}
              title={item.dokter.nama}
              key={item.id}
            />
          ))}
        </Stack>
      </ActionDialog>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    stateHistoryFarmasi: state.history.farmasi,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actFetchObatByRkun: ({ rkun_id }: any) =>
      dispatch(fetchObatByRkun({ rkun_id })),
    // actGetAntrianPoli: (id: number) => dispatch(getAntrianPoli(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryObat);
